import React, { useEffect, useState } from "react";
import { Accordion, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import ContentHeading from "../../shared/commonComponents/ContentHeading";
import { Button, SelectDropdown, TextInput } from "../../shared/inputs";
import TeamMember from "./TeamMember";
import {
  OnboardingAxios,
  NetworkAxios,
  IAMAxios,
  ProgramSetupAxios,
} from "../../API";
import Tabs from "../../shared/Tabs/Tabs";
import TabPanel from "../../shared/Tabs/TabPanel";
import { useDispatch } from "react-redux";
import appStateSlice from "../../store/appState/appStateSlice";
import { useLocation } from "react-router-dom";
//import Profile from "../../shared/profile/Profile";
import ShowMore from "../../shared/commonComponents/ShowMore";

const Connections = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [searchResult, setSearchResult] = useState([]);
  const [activeKey, setActiveKey] = useState("1");
  const [teamCoach, setTeamCoach] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [myConnections, setMyConnections] = useState([]);
  const [myRequests, setMyRequests] = useState([]);

  const userDetails = useSelector((state) => state.auth.loggedInUser);
  const tabs = useSelector((state) => state.appState.connectionTabs);
  const activeTab = useSelector((state) => state.appState.activeTab);
  const [rolesList, setRolesList] = useState([]);
  const [missionList, setMissionList] = useState([]);
  const [geographyList, setGeographyList] = useState([]);

  const [pageNo, setPageNo] = useState(1);
  const [perPageCount, setPerPageCount] = useState(500);
  //const [totalCount, setTotalCount] = useState(10);
  const [noDataFound, setNoDataFound] = useState(false);

  const [nameOrEmail, setNameOrEmail] = useState("");
  const [selectedRole, setSelectedRole] = useState(0);
  const [selectedMission, setSelectedMission] = useState(0);
  const [selectedGeography, setSelectedGeography] = useState(0);
  const [searchResultCount, setSearchResultCount] = useState(100);

  // const toggleTeam = (key) => {
  //   if (activeKey === "0") {
  //     setActiveKey("" + key);
  //   } else {
  //     setActiveKey("0");
  //   }
  // };

  useEffect(() => {
    // clearSearch();
    if (!tabs.some((item) => item.name === activeTab)) {
      dispatch(appStateSlice.actions.setActiveTab("My Connections"));
    }
  }, [activeTab]);

  useEffect(() => {
    if (location.state && location.state.tab === "Search") {
      dispatch(appStateSlice.actions.setActiveTab("Search"));
    } else dispatch(appStateSlice.actions.setActiveTab("My Connections"));
    OnboardingAxios.get(
      "OfferingUsers/getmyteamconnections/" + userDetails.offeringUserId
    ).then(function (response) {
      if (response.data.length > 0) {
        let data = response.data;
        let coach = data
          .filter((item) => item.roleId === 5)
          .map((item) => {
            return { ...item, frame: "coach" };
          });
        data = data.filter((item) => item.roleId !== 5);
        data = data.filter(
          (item) => item.offeringUserId !== userDetails.offeringUserId
        );

        setTeamMembers(data);
        setTeamCoach(coach);
      }
    });
    setIsLoading(true);
    NetworkAxios.get(
      "Connection/getmyconnections/" + userDetails.offeringUserId
    ).then(function (response) {
      let data = response.data;
      setMyConnections(data);
      setIsLoading(false);
    });

    IAMAxios.get("Roles/bydisplayroles").then((res) => {
      let roleList = res.data.map((item) => {
        return { label: item.shortName, value: item.id };
      });
      let roles = [{ label: "All", value: "0" }, ...roleList];
      setRolesList(roles);
    });

    ProgramSetupAxios.get(
      "OfferingMission/getbasicbyoffering/" + userDetails.offeringId
    ).then((res) => {
      let missionList = res.data.map((item) => {
        return { label: item.missionName, value: item.missionId };
      });
      let missions = [{ label: "All", value: "0" }, ...missionList];
      setMissionList(missions);
    });

    ProgramSetupAxios.get(
      "OfferingGeography/getbyoffering/" + userDetails.offeringId
    ).then((res) => {
      let geoList = res.data.map((item) => {
        return { label: item.name, value: item.id };
      });
      let geo = [{ label: "All", value: "0" }, ...geoList];
      setGeographyList(geo);
    });

    getMyRequests();
  }, []);

  const [isLoading, setIsLoading] = useState(true);
  const searchMembers = () => {
    setIsLoading(true);
    let queryString = "";
    if (
      nameOrEmail ||
      parseInt(selectedRole) > 0 ||
      parseInt(selectedMission) > 0 ||
      parseInt(selectedGeography) > 0
    ) {
      queryString = queryString.concat("?");
      if (nameOrEmail) {
        queryString = queryString.concat("NameOrEmail=" + nameOrEmail + "&");
      }
      if (parseInt(selectedRole) > 0) {
        queryString = queryString.concat("RoleId=" + selectedRole + "&");
      }
      if (parseInt(selectedMission) > 0) {
        queryString = queryString.concat("MissionId=" + selectedMission + "&");
      }
      if (parseInt(selectedGeography) > 0) {
        queryString = queryString.concat("GeographyId=" + selectedGeography);
      }
      console.log("queryString", queryString);
    }

    OnboardingAxios.get(
      "OfferingUsers/search/" +
      userDetails.offeringUserId +
      "/" +
      pageNo +
      "/" +
      perPageCount +
      queryString
    ).then((res) => {
      let data = res.data;
      setIsLoading(false);
      if (data) {
        data = data.filter(
          (item) => item.offeringUserId !== userDetails.offeringUserId
        );
        setSearchResult(data);
        setNoDataFound(false);
      } else {
        setNoDataFound(true);
        setSearchResult([]);
      }
    });

    setActiveKey("0");
  };

  const updateStatus = (id, status) => {
    let localTeam = [...teamMembers];
    let memberDetails = null;
    let meberIndex = localTeam.findIndex((item) => item.offeringUserId === id);
    if (meberIndex >= 0) {
      localTeam[meberIndex].connectionStatus = status;
      memberDetails = localTeam[meberIndex];
      setTeamMembers(localTeam);
      if (searchResult.length > 0) {
        let allteamIndex = searchResult.findIndex(
          (item) => item.offeringUserId === id
        );
        if (allteamIndex >= 0) {
          let temp = [...searchResult];
          temp[allteamIndex].connectionStatus = status;
          memberDetails = temp[allteamIndex];
          setSearchResult([]);
          setSearchResult(temp);
        }
      }
    } else {
      let localCoach = [...teamCoach];
      let coachIndex = localCoach.findIndex(
        (item) => item.offeringUserId === id
      );
      if (coachIndex >= 0) {
        localCoach[coachIndex].connectionStatus = status;
        memberDetails = localCoach[coachIndex];
        setTeamCoach(localCoach);
      }

      let allteamIndex = searchResult.findIndex(
        (item) => item.offeringUserId === id
      );
      if (allteamIndex >= 0) {
        let temp = [...searchResult];
        temp[allteamIndex].connectionStatus = status;
        memberDetails = temp[allteamIndex];
        setSearchResult([]);
        setSearchResult(temp);
      }
    }

    if (status === 3) {
      let localConnections = [...myConnections];
      memberDetails && localConnections.push(memberDetails);
      console.log(localConnections);
      console.log(memberDetails);
      setMyConnections(localConnections);
    }
  };

  const clearSearch = () => {
    setNameOrEmail("");
    setSelectedRole(0);
    setSelectedMission(0);
    setSelectedGeography(0);
    setSearchResult([]);
    setActiveKey("3");
    setSearchResultCount(100);
  };

  const getMyConnections = () => {
    setIsLoading(true);
    NetworkAxios.get(
      "Connection/getmyconnections/" + userDetails.offeringUserId
    ).then(function (response) {
      let data = response.data;
      setMyConnections(data);
      setIsLoading(false);
    });
  };
  const getMyRequests = () => {
    NetworkAxios.get(
      "Connection/getmyconnectionrequest/" + userDetails.offeringUserId
    ).then(function (response) {
      let data = response.data;
      setMyRequests(data);
    });
  };

  const getMyTeamMembers = () => {
    OnboardingAxios.get(
      "OfferingUsers/getmyteamconnections/" + userDetails.offeringUserId
    ).then(function (response) {
      let data = response.data;
      let coach = data
        .filter((item) => item.roleId === 5)
        .map((item) => {
          return { ...item, frame: "coach" };
        });
      data = data.filter((item) => item.roleId !== 5);
      data = data.filter(
        (item) => item.offeringUserId !== userDetails.offeringUserId
      );

      setTeamMembers(data);
      setTeamCoach(coach);
    });
  };

  const updateRequest = () => {
    getMyTeamMembers();
    getMyConnections();
    getMyRequests();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      searchMembers();
    }
  };

  const loadMoreResult = () => {
    setSearchResultCount(searchResultCount + 100);
  };

  return (
    <>
      <Tabs tabs={tabs} activeTab={activeTab} />
      <div className="px-3 py-4 flex-content content-height">
        <TabPanel value={activeTab} name="My Connections" key="MyConnections" loading={isLoading}>
          <div className="my-team-section scroll-content">
            <Accordion flush className="mb-4" defaultActiveKey="2">
              <Accordion.Item eventKey="1">
                <Accordion.Button as="div">My Team</Accordion.Button>
                <Accordion.Body>
                  {teamCoach &&
                    teamCoach.map((item) => {
                      return (
                        <TeamMember
                          className="large coach"
                          {...item}
                          id={item.userId}
                          userId={userDetails.offeringUserId}
                          key={"team-member-" + item.id}
                          updateStatus={updateStatus}
                        />
                      );
                    })}

                  <div className="search-result row">
                    {teamMembers ?
                      teamMembers.map((item) => {
                        return (
                          <>
                            <div
                              className="col search-item"
                              key={"team-member-search" + item.id}
                            >
                              <TeamMember
                                {...item}
                                id={item.userId}
                                userId={userDetails.offeringUserId}
                                updateStatus={updateStatus}
                              />
                            </div>
                          </>
                        );
                      })
                      : (
                        <div className="connection-note">
                          <span>
                            Your team does not have any team members yet.
                          </span>
                        </div>
                      )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Button as="div">My Connections</Accordion.Button>
                <Accordion.Body>
                  {myRequests && myRequests.length > 0 && (
                    <div className="search-result row request-received">
                      <div>Requests Received</div>
                      {myRequests.map((item) => {
                        return (
                          <>
                            <div
                              className="col search-item"
                              key={"team-member-myconnection" + item.id}
                            >
                              <TeamMember
                                {...item}
                                id={item.userId}
                                userId={userDetails.offeringUserId}
                                updateStatus={updateRequest}
                              />
                            </div>
                          </>
                        );
                      })}
                    </div>
                  )}
                  <div className="search-result row">
                    {myConnections.length > 0 ? (
                      myConnections.map((item) => {
                        return (
                          <>
                            <div
                              className="col search-item"
                              key={"team-member-myconnection" + item.id}
                            >
                              <TeamMember
                                {...item}
                                id={item.userId}
                                userId={userDetails.offeringUserId}
                                updateStatus={updateStatus}
                              />
                            </div>
                          </>
                        );
                      })
                    ) : (
                      <div className="connection-note">
                        {isLoading ? <>Loading <Spinner animation="border" className="ms-2" variant="primary" size="sm" /></>
                          :
                          <span>
                            You haven't connected with anyone yet. Your approved
                            connections will be shown here.
                          </span>
                        }
                      </div>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </TabPanel>
        <TabPanel value={activeTab} name="Search" key="Search" >
          <ContentHeading title={"Search People Across the Program"} />
          <div className="member-filter my-4">
            <div className="filter-content row">
              <TextInput
                placeholder=""
                label="Name/Email"
                onKeyDown={handleKeyDown}
                className="col-md"
                value={nameOrEmail}
                onChange={(e) => setNameOrEmail(e.target.value)}
              />
              <SelectDropdown
                label="Role"
                options={rolesList}
                className="col-md"
                value={selectedRole}
                onChange={(v) => setSelectedRole(v.target.value)}
              />
              <SelectDropdown
                label="Mission"
                options={missionList}
                className="col-md"
                value={selectedMission}
                onChange={(v) => setSelectedMission(v.target.value)}
              />
              <SelectDropdown
                label="Geography"
                options={geographyList}
                className="col-md"
                value={selectedGeography}
                onChange={(v) => setSelectedGeography(v.target.value)}
              />
              <div className="cdx-form-group col-md search-button-container">
                <Button
                  className="search-button mr-2"
                  onClick={() => searchMembers()}
                >
                  {isLoading ? <>Searching</> : <>Search</>}
                </Button>
                <Button
                  className="search-button"
                  onClick={() => clearSearch()}
                  disabled={
                    !searchResult.length > 0 &&
                    !selectedRole != 0 &&
                    !selectedMission != 0 &&
                    !selectedGeography != 0 &&
                    !activeKey != 3 &&
                    !nameOrEmail != ""
                  }
                >
                  Clear
                </Button>
              </div>
            </div>
            {noDataFound && (
              <div className="success-message">No data found.</div>
            )}
          </div>
          <div className="scroll-content">
            {searchResult.length > 0 && (
              <>
                <ContentHeading title={"Search Results"} />
                <div className="search-result row">
                  {searchResult.slice(0, searchResultCount).map((item) => {
                    return (
                      <>
                        <div
                          className="col search-item"
                          key={"team-member-search-result" + item.id}
                        >
                          <TeamMember
                            {...item}
                            id={item.userId}
                            userId={userDetails.offeringUserId}
                            className="medium"
                            updateStatus={updateStatus}
                          />
                        </div>
                      </>
                    );
                  })}
                  {searchResult.length > searchResultCount && (
                    <ShowMore onClick={loadMoreResult} />
                  )}
                </div>
              </>
            )}
          </div>
        </TabPanel>
      </div>
    </>
  );
};

export default Connections;
